import { getSluggedProps } from './getSluggedProps.js';
/**
 * Takes an object of type TypographyProperties property and transforms it into the ThemePropertiesTypography object type.
 * @param {TypographyProperties} typography - An object of type TypographyProperties
 * @returns {ThemePropertiesTypography} An object of type ThemePropertiesTypography
 */
export function getTypographyOptions(typography) {
    return Object.assign(Object.assign({}, (typography.fontSizes && {
        fontSizes: getSluggedProps(typography.fontSizes, 'size'),
    })), (typography.fontFamilies && {
        fontFamilies: getSluggedProps(typography.fontFamilies, 'fontFamily'),
    }));
}
